// extracted by mini-css-extract-plugin
module.exports = {"root":"target_root__2th9N","heading":"target_heading__3HTev","image":"target_image__1aonV","grid":"target_grid__2OZ83","description":"target_description__2cLZa"};